<template>
	<DialogControl v-model="open" :title="t('Moyens')" :subtitle="campaign.label" icon="campaign" max-width="600" :attach="overlayTarget">
		<v-list class="pa-0">
			<v-list-item v-for="means in campaign.applicationDomains" :key="means.applicationDomainId" :title="means.label" :subtitle="means.orderEndDate ? `${t('PromoOrderEndDate')} ${format.date(means.orderEndDate)}` : ''" rounded="lg" class="px-0">
				<template v-if="editable" #append>
					<div class="d-flex flex-wrap justify-end ga-2">
						<v-btn variant="text" prepend-icon="menu_book" size="small" @click="ops.run({ type: 'gotoCatalog', campaignId: campaign.id, applicationDomainId: means.applicationDomainId })">{{ t('GotoCatalog') }}</v-btn>
						<v-btn v-if="means.canOrder" prepend-icon="shopping_cart" size="small" color="primary" variant="tonal" @click="ops.run({ type: 'orderMeans', campaignId: campaign.id, applicationDomainId: means.applicationDomainId })">{{ t('Checkout') }}</v-btn>
					</div>
				</template>
			</v-list-item>
		</v-list>
		<template #actions>
			<v-btn color="primary" variant="tonal" @click="open = false">{{ t('Close') }}</v-btn>
		</template>
	</DialogControl>
</template>

<script setup>
import { inject } from 'vue';
import DialogControl from '@/components/controls/DialogControl.vue';
import { usePromoStep } from '@/composables/usePromoStep';

const open = defineModel({ type: Boolean, default: false });
defineProps({
	campaign: { type: Object, required: true },
	editable: { type: Boolean, default: false },
});

const { ops, format, t } = usePromoStep();
const overlayTarget = inject('overlayTarget', null);
</script>
